/* Priyanka Musical House – product page scripts (vanilla JS, no dependencies).
   - Live updates of [data-pmh-live] / [data-pmh-state] elements on variant change
   - Mobile gallery dots
   - <pmh-pincode-check>   delivery / COD checker
   - <pmh-sticky-atc>      mobile sticky buy bar
   - <pmh-product-details> tabs (desktop) / accordions (mobile) + "Read full description"
   - <pmh-rail>            horizontal product carousels (arrows on desktop)
   - <pmh-recently-viewed> recently viewed products (localStorage)
*/
(function () {
  if (window.pmhProductLoaded) return;
  window.pmhProductLoaded = true;

  var RV_KEY = 'pmh_recently_viewed';
  var PIN_KEY = 'pmh_pincode';
  var CHECK_SVG =
    '<svg class="pmh-pin__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) {
      return null;
    }
    return null;
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cleanTitle(str) {
    return String(str == null ? '' : str).replace(/&amp;/g, '&');
  }

  var moneyFormatter;
  var moneyCurrency;
  function formatINR(paise, currency) {
    var cur = currency || 'INR';
    var isInr = cur === 'INR';
    try {
      if (!moneyFormatter || moneyCurrency !== cur) {
        moneyFormatter = new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: cur,
          minimumFractionDigits: 0,
          maximumFractionDigits: isInr ? 0 : 2,
        });
        moneyCurrency = cur;
      }
      return moneyFormatter.format(isInr ? Math.round(paise / 100) : paise / 100);
    } catch (e) {
      var n = Math.round(paise / 100);
      var grouped;
      try {
        grouped = n.toLocaleString('en-IN');
      } catch (e2) {
        grouped = String(n);
      }
      return (isInr ? '₹' : cur + ' ') + grouped;
    }
  }

  /* ---------- Live variant updates ----------
     Scoped to the <product-info> that published the change. Inside Dawn quick-add
     modals every id is rewritten to "quickadd-<section>" (quick-add.js
     preventDuplicatedIDs) while the fetched HTML keeps the original ids, so local
     ids are mapped back to the original section id, the same way Dawn's
     updateSourceFromDestination() does. */
  function onVariantChange(event) {
    var d = event && event.data;
    var html = d && d.html;
    if (!html || typeof html.getElementById !== 'function' || !d.sectionId) return;
    var srcInfo = typeof html.querySelector === 'function' ? html.querySelector('product-info') : null;
    var srcPid = srcInfo && srcInfo.dataset ? srcInfo.dataset.productId : null;
    document.querySelectorAll('product-info').forEach(function (info) {
      var original = info.dataset.originalSection || info.dataset.section;
      if (original !== d.sectionId) return;
      if (srcPid && info.dataset.productId && info.dataset.productId !== srcPid) return;
      var local = info.dataset.section || original;
      var mapId = function (id) {
        return local !== original ? id.split(local).join(original) : id;
      };
      info.querySelectorAll('[data-pmh-live][id]').forEach(function (el) {
        var source = html.getElementById(mapId(el.id));
        if (!source) return;
        el.innerHTML = source.innerHTML;
        el.className = source.className;
      });
      info.querySelectorAll('[data-pmh-state][id]').forEach(function (el) {
        var source = html.getElementById(mapId(el.id));
        if (source && source.dataset.state) el.dataset.state = source.dataset.state;
      });
      info.querySelectorAll('pmh-sticky-atc').forEach(function (bar) {
        if (typeof bar.syncState === 'function') bar.syncState();
      });
      info.querySelectorAll('media-gallery').forEach(function (gallery) {
        window.setTimeout(function () {
          initGalleryDots(gallery);
        }, 60);
      });
    });
  }

  /* Dawn's setUnavailable() (an option combination that does not exist) returns
     before publishing variantChange; it hides #price-<section>. Watch for that
     and show the "not available" state in our live lines. */
  function markUnavailable(info) {
    var sec = info.dataset.section;
    if (!sec) return;
    var stock = document.getElementById('pmh-stock-' + sec);
    if (stock && info.contains(stock)) {
      stock.className = 'pmh-stock pmh-stock--unavailable';
      stock.innerHTML =
        '<span class="pmh-stock__dot" aria-hidden="true"></span><span>Not available in this option</span>';
    }
    var cta = document.getElementById('pmh-soldout-' + sec);
    if (cta && info.contains(cta)) cta.innerHTML = '';
    var buy = document.getElementById('pmh-buy-' + sec);
    if (buy && info.contains(buy)) buy.dataset.state = 'unavailable';
    info.querySelectorAll('pmh-sticky-atc').forEach(function (bar) {
      if (typeof bar.syncState === 'function') bar.syncState();
    });
  }

  function watchUnavailable(info) {
    if (!info || info._pmhWatch || !('MutationObserver' in window)) return;
    var sec = info.dataset.section;
    var price = sec ? document.getElementById('price-' + sec) : null;
    if (!price || !info.contains(price)) return;
    info._pmhWatch = true;
    new MutationObserver(function () {
      if (price.classList.contains('hidden')) markUnavailable(info);
    }).observe(price, { attributes: true, attributeFilter: ['class'] });
  }

  function watchAllProductInfo(root) {
    (root || document).querySelectorAll('product-info').forEach(watchUnavailable);
  }

  function initLiveUpdates() {
    watchAllProductInfo(document);
    /* Quick-add modals inject their product-info later: watch them when filled. */
    if ('MutationObserver' in window) {
      document.querySelectorAll('quick-add-modal').forEach(function (modal) {
        new MutationObserver(function () {
          watchAllProductInfo(modal);
        }).observe(modal, { childList: true, subtree: true });
      });
    }
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }

  /* ---------- Mobile gallery: dots under the swipeable images ---------- */
  var galleryMq = window.matchMedia('(max-width: 749px)');

  function initGalleryDots(gallery) {
    if (!gallery) return;
    var viewer = gallery.querySelector('slider-component[id^="GalleryViewer"]');
    var slider = viewer && viewer.querySelector('[id^="Slider-Gallery"]');
    if (!slider) return;
    var old = viewer.querySelector('.pmh-gallery-dots');
    if (old) old.remove();
    gallery.classList.remove('pmh-has-dots');
    if (!galleryMq.matches) return;

    var items = Array.prototype.filter.call(slider.querySelectorAll('.product__media-item'), function (li) {
      return li.offsetWidth > 0;
    });
    if (items.length < 2 || items.length > 12) return;

    var dots = document.createElement('div');
    dots.className = 'pmh-gallery-dots';
    dots.setAttribute('aria-hidden', 'true');
    items.forEach(function (item, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.tabIndex = -1;
      dot.className = 'pmh-gallery-dots__dot';
      dot.addEventListener('click', function () {
        slider.scrollTo({ left: item.offsetLeft - items[0].offsetLeft, behavior: 'smooth' });
      });
      dots.appendChild(dot);
    });
    viewer.appendChild(dots);
    gallery.classList.add('pmh-has-dots');

    var setActive = function () {
      var w = items[0].offsetWidth || slider.clientWidth || 1;
      var index = Math.min(items.length - 1, Math.max(0, Math.round(slider.scrollLeft / w)));
      Array.prototype.forEach.call(dots.children, function (dot, i) {
        dot.classList.toggle('is-active', i === index);
      });
    };
    setActive();
    if (!slider._pmhDots) {
      slider._pmhDots = true;
      slider.addEventListener(
        'scroll',
        function () {
          var current = viewer.querySelector('.pmh-gallery-dots');
          if (current && current._setActive) current._setActive();
        },
        { passive: true }
      );
    }
    dots._setActive = setActive;
  }

  function initAllGalleries() {
    document.querySelectorAll('product-info media-gallery').forEach(initGalleryDots);
  }

  /* ---------- Recently viewed: record current product ---------- */
  function readRecent() {
    var raw = store(RV_KEY);
    if (!raw) return [];
    try {
      var list = JSON.parse(raw);
      return Array.isArray(list)
        ? list.filter(function (h) {
            return typeof h === 'string' && h;
          })
        : [];
    } catch (e) {
      return [];
    }
  }

  function writeRecent(list) {
    store(RV_KEY, JSON.stringify(list.slice(0, 12)));
  }

  function recordCurrentProduct() {
    var el = document.querySelector('product-info:not([data-original-section]) [data-pmh-product-handle]');
    if (!el) return;
    var handle = el.getAttribute('data-pmh-product-handle');
    if (!handle) return;
    var list = readRecent().filter(function (h) {
      return h !== handle;
    });
    list.unshift(handle);
    writeRecent(list);
  }

  /* ---------- Pincode checker ---------- */
  if (!customElements.get('pmh-pincode-check')) {
    customElements.define(
      'pmh-pincode-check',
      class PmhPincodeCheck extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          this.form = this.querySelector('form');
          this.input = this.querySelector('input');
          this.result = this.querySelector('.pmh-pin__result');
          if (!this.form || !this.input || !this.result) return;
          this.codes = new Set(
            (this.dataset.cod || '')
              .split(/[\s,;]+/)
              .map(function (s) {
                return s.trim();
              })
              .filter(Boolean)
          );
          var self = this;
          this.form.addEventListener('submit', function (e) {
            e.preventDefault();
            self.check(true);
          });
          this.input.addEventListener('input', function () {
            var clean = self.input.value.replace(/\D/g, '').slice(0, 6);
            if (clean !== self.input.value) self.input.value = clean;
            if (clean.length === 6) self.check(true);
            else if (!clean.length) self.render('', '');
          });
          var saved = store(PIN_KEY);
          if (saved && /^[1-9][0-9]{5}$/.test(saved)) {
            this.input.value = saved;
            this.check(false);
          }
        }

        check(save) {
          var pin = (this.input.value || '').trim();
          if (!/^[1-9][0-9]{5}$/.test(pin)) {
            this.render('error', '<p class="pmh-pin__msg">Please enter a valid 6-digit pincode, e.g. 110006</p>');
            return;
          }
          if (save) store(PIN_KEY, pin);
          var local = this.dataset.daysLocal || '1–3 business days';
          var india = this.dataset.daysIndia || '3–7 business days';
          if (this.codes.has(pin)) {
            this.render(
              'ok',
              '<p class="pmh-pin__msg">' + CHECK_SVG + '<span>Delivery to <strong>' + escapeHtml(pin) + '</strong> in ' +
                escapeHtml(local) + '</span></p>' +
                '<p class="pmh-pin__sub">Cash on Delivery available</p>'
            );
          } else {
            this.render(
              'ok',
              '<p class="pmh-pin__msg">' + CHECK_SVG + '<span>Delivery to <strong>' + escapeHtml(pin) + '</strong> in ' +
                escapeHtml(india) + '</span></p>' +
                '<p class="pmh-pin__sub">Prepaid only for this pincode (UPI, cards, net banking, EMI)</p>'
            );
          }
        }

        render(state, html) {
          this.result.className = 'pmh-pin__result' + (state ? ' pmh-pin__result--' + state : '');
          this.result.innerHTML = html;
        }
      }
    );
  }

  /* ---------- Sticky buy bar (mobile / tablet) ---------- */
  if (!customElements.get('pmh-sticky-atc')) {
    customElements.define(
      'pmh-sticky-atc',
      class PmhStickyAtc extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          /* Never run the fixed bar inside a quick-add modal */
          if (this.closest('quick-add-modal') || this.closest('product-info[data-original-section]')) return;
          this._ready = true;
          this.sectionId = this.dataset.section;
          this.atcBtn = this.querySelector('[data-pmh-sticky-atc]');
          this.waBtn = this.querySelector('[data-pmh-sticky-wa]');
          this.waLabel = this.querySelector('[data-pmh-sticky-wa-label]');
          this.mq = window.matchMedia('(max-width: 989px)');
          this.passed = false;
          var self = this;

          this.atcBtn.addEventListener('click', function () {
            var submit = self.getSubmit();
            if (self.getState() === 'buy' && submit && !submit.disabled) {
              submit.click();
            } else {
              var target = self.getTarget();
              if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          });

          this.syncState();

          var buy = this.getBuy();
          if (buy && 'MutationObserver' in window) {
            this.stateObserver = new MutationObserver(this.syncState.bind(this));
            this.stateObserver.observe(buy, { attributes: true, attributeFilter: ['data-state'] });
          }

          this.onMq = function () {
            self.update();
          };
          if (this.mq.addEventListener) this.mq.addEventListener('change', this.onMq);
          else if (this.mq.addListener) this.mq.addListener(this.onMq);

          /* Show once the main buy area has scrolled above the top of the screen.
             A scroll check (not IntersectionObserver) also covers jumps, e.g. back to top. */
          var ticking = false;
          this.onScroll = function () {
            if (ticking) return;
            ticking = true;
            window.requestAnimationFrame(function () {
              ticking = false;
              var target = self.getTarget();
              var passed = !!target && target.getBoundingClientRect().bottom < 0;
              if (passed !== self.passed) {
                self.passed = passed;
                self.update();
              }
            });
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.onScroll();
        }

        disconnectedCallback() {
          if (this.onScroll) {
            window.removeEventListener('scroll', this.onScroll);
            window.removeEventListener('resize', this.onScroll);
          }
          if (this.stateObserver) this.stateObserver.disconnect();
          if (!this._ready) return;
          document.body.classList.remove('pmh-sticky-visible');
        }

        getBuy() {
          return document.getElementById('pmh-buy-' + this.sectionId);
        }

        getState() {
          var buy = this.getBuy();
          return (buy && buy.dataset.state) || 'buy';
        }

        getSubmit() {
          return document.getElementById('ProductSubmitButton-' + this.sectionId);
        }

        getTarget() {
          var root = document.getElementById('MainProduct-' + this.sectionId) || document;
          return this.getBuy() || root.querySelector('.product__title');
        }

        syncState() {
          if (!this.atcBtn || !this.waBtn) return;
          var state = this.getState();
          var useWa = state === 'soldout' || state === 'zero';
          this.atcBtn.hidden = useWa;
          this.waBtn.hidden = !useWa;
          if (useWa) {
            var zero = state === 'zero';
            if (this.waLabel) this.waLabel.textContent = zero ? 'Get best price' : 'Ask on WhatsApp';
            var href = zero ? this.waBtn.dataset.hrefZero : this.waBtn.dataset.hrefSold;
            if (href) this.waBtn.setAttribute('href', href);
          }
        }

        update() {
          this.toggle(this.passed && this.mq.matches);
        }

        toggle(show) {
          if (show) {
            this.syncState();
            var nav = document.querySelector('.pmh-bottom-nav');
            var navH = 0;
            if (nav) {
              var cs = window.getComputedStyle(nav);
              if (cs.display !== 'none' && cs.visibility !== 'hidden') navH = nav.offsetHeight;
            }
            this.style.bottom = navH ? navH + 'px' : '';
            this.classList.toggle('pmh-sticky--above-nav', navH > 0);
            this.hidden = false;
            var self = this;
            window.requestAnimationFrame(function () {
              self.classList.add('is-visible');
            });
            document.body.classList.add('pmh-sticky-visible');
          } else {
            this.classList.remove('is-visible');
            this.hidden = true;
            document.body.classList.remove('pmh-sticky-visible');
          }
        }
      }
    );
  }

  /* ---------- Product details: tabs on desktop, accordions on mobile ---------- */
  if (!customElements.get('pmh-product-details')) {
    customElements.define(
      'pmh-product-details',
      class PmhProductDetails extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(this.querySelectorAll('.pmh-details__panel'));
          this.mq = window.matchMedia('(min-width: 990px)');
          var self = this;
          this.tabs.forEach(function (tab, i) {
            tab.addEventListener('click', function () {
              self.select(i, true);
            });
            tab.addEventListener('keydown', function (e) {
              var next = null;
              if (e.key === 'ArrowRight') next = (i + 1) % self.tabs.length;
              if (e.key === 'ArrowLeft') next = (i - 1 + self.tabs.length) % self.tabs.length;
              if (next !== null) {
                e.preventDefault();
                self.select(next, true);
              }
            });
          });
          this.panels.forEach(function (panel, i) {
            panel.addEventListener('toggle', function () {
              if (!self.mq.matches && panel.open) self.setActiveTab(i);
              if (panel.open) self.measureClamp();
            });
          });
          var onChange = function () {
            self.applyMode();
            self.measureClamp(true);
          };
          if (this.mq.addEventListener) this.mq.addEventListener('change', onChange);
          else if (this.mq.addListener) this.mq.addListener(onChange);
          this.applyMode();
          this.initClamp();
        }

        applyMode() {
          if (this.mq.matches) {
            var active = this.tabs.findIndex(function (t) {
              return t.getAttribute('aria-selected') === 'true';
            });
            this.select(active < 0 ? 0 : active, false);
          }
        }

        setActiveTab(index) {
          this.tabs.forEach(function (tab, i) {
            tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
            tab.tabIndex = i === index ? 0 : -1;
          });
        }

        select(index, focus) {
          this.setActiveTab(index);
          this.panels.forEach(function (panel, i) {
            panel.open = i === index;
            panel.classList.toggle('is-active', i === index);
          });
          if (focus && this.tabs[index]) this.tabs[index].focus();
        }

        /* Long (often scraped) descriptions: show a preview + "Read full description" */
        initClamp() {
          this.clamp = this.querySelector('[data-pmh-clamp]');
          if (!this.clamp) return;
          this.clampBtn = this.clamp.querySelector('[data-pmh-clamp-toggle]');
          var self = this;
          if (this.clampBtn) {
            this.clampBtn.addEventListener('click', function () {
              self.expanded = true;
              self.clamp.classList.remove('is-clamped');
              self.clamp.style.removeProperty('--pmh-clamp-h');
              self.clampBtn.hidden = true;
            });
          }
          this.measureClamp();
          window.addEventListener('load', function () {
            self.measureClamp();
          });
        }

        measureClamp(force) {
          if (!this.clamp || this.expanded) return;
          var desc = this.clamp.querySelector('.pmh-desc');
          if (!desc || !desc.offsetParent) return;
          var limit = this.mq.matches ? 560 : 360;
          if (force || !this.clamp.classList.contains('is-clamped')) {
            var tall = desc.scrollHeight > limit + 160;
            this.clamp.classList.toggle('is-clamped', tall);
            this.clamp.style.setProperty('--pmh-clamp-h', limit + 'px');
            if (this.clampBtn) this.clampBtn.hidden = !tall;
          }
        }
      }
    );
  }

  /* ---------- Horizontal product rail ---------- */
  if (!customElements.get('pmh-rail')) {
    customElements.define(
      'pmh-rail',
      class PmhRail extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          this.list = this.querySelector('[data-pmh-rail-list]');
          this.nav = this.querySelector('.pmh-rail__nav');
          this.prev = this.querySelector('[data-pmh-rail-prev]');
          this.next = this.querySelector('[data-pmh-rail-next]');
          if (!this.list) return;
          var self = this;
          if (this.prev) {
            this.prev.addEventListener('click', function () {
              self.go(-1);
            });
          }
          if (this.next) {
            this.next.addEventListener('click', function () {
              self.go(1);
            });
          }
          this.list.addEventListener(
            'scroll',
            function () {
              self.refresh();
            },
            { passive: true }
          );
          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(function () {
              self.refresh();
            });
            this.ro.observe(this.list);
          }
          this.refresh();
        }

        disconnectedCallback() {
          if (this.ro) this.ro.disconnect();
        }

        step() {
          var item = this.list.children[0];
          if (!item) return this.list.clientWidth;
          var second = this.list.children[1];
          var itemStep = second ? second.offsetLeft - item.offsetLeft : item.offsetWidth;
          var perView = Math.max(1, Math.floor((this.list.clientWidth + 2) / itemStep));
          return perView * itemStep;
        }

        go(dir) {
          this.list.scrollBy({ left: dir * this.step(), behavior: 'smooth' });
        }

        refresh() {
          if (!this.list || !this.nav) return;
          var max = this.list.scrollWidth - this.list.clientWidth;
          var overflow = max > 4;
          this.nav.hidden = !overflow;
          if (this.prev) this.prev.disabled = this.list.scrollLeft <= 2;
          if (this.next) this.next.disabled = this.list.scrollLeft >= max - 2;
        }
      }
    );
  }

  /* ---------- Recently viewed products ---------- */
  if (!customElements.get('pmh-recently-viewed')) {
    customElements.define(
      'pmh-recently-viewed',
      class PmhRecentlyViewed extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          this.load();
        }

        load() {
          var self = this;
          var current = this.dataset.currentHandle || '';
          var limit = parseInt(this.dataset.limit || '10', 10) || 10;
          var handles = readRecent()
            .filter(function (h) {
              return h !== current;
            })
            .slice(0, limit);
          if (!handles.length) return;
          var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

          Promise.all(
            handles.map(function (handle) {
              return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', {
                headers: { Accept: 'application/json' },
              })
                .then(function (r) {
                  if (r.status === 404) return { missing: handle };
                  return r.ok ? r.json() : null;
                })
                .catch(function () {
                  return null;
                });
            })
          ).then(function (results) {
            var missing = results
              .filter(function (p) {
                return p && p.missing;
              })
              .map(function (p) {
                return p.missing;
              });
            if (missing.length) {
              writeRecent(
                readRecent().filter(function (h) {
                  return missing.indexOf(h) === -1;
                })
              );
            }
            var products = results.filter(function (p) {
              return p && !p.missing && p.handle;
            });
            if (!products.length) return;
            self.render(products);
          });
        }

        imageUrl(src, width) {
          if (!src) return '';
          var url = src.indexOf('//') === 0 ? 'https:' + src : src;
          return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
        }

        render(products) {
          var self = this;
          var zeroLabel = this.dataset.zeroLabel || 'Call for best price';
          var currency = this.dataset.currency || 'INR';
          var soldLabel = this.dataset.soldLabel || 'Sold out';
          var list = this.querySelector('.pmh-rv__list');
          if (!list) return;
          list.innerHTML = products
            .map(function (p) {
              var title = cleanTitle(p.title);
              var img = p.featured_image
                ? '<img src="' + escapeHtml(self.imageUrl(p.featured_image, 400)) + '" srcset="' +
                  escapeHtml(self.imageUrl(p.featured_image, 300)) + ' 300w, ' +
                  escapeHtml(self.imageUrl(p.featured_image, 500)) + ' 500w" sizes="(min-width: 990px) 240px, 42vw" alt="' +
                  escapeHtml(title) + '" loading="lazy" width="400" height="400">'
                : '<svg class="pmh-rvc__noimg" viewBox="0 0 24 24" width="40" height="40" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><rect x="3" y="4" width="18" height="16" rx="2"/><circle cx="9" cy="10" r="1.6"/><path d="M21 16l-5-5-8 8"/></svg>';
              var price;
              var badge = '';
              if (!p.price) {
                price = '<span class="pmh-rvc__zero">' + escapeHtml(zeroLabel) + '</span>';
              } else {
                price = '<span class="pmh-rvc__now">' + (p.price_varies ? 'From ' : '') + formatINR(p.price, currency) + '</span>';
                if (p.compare_at_price && p.compare_at_price > p.price) {
                  price += ' <s class="pmh-rvc__mrp">' + formatINR(p.compare_at_price, currency) + '</s>';
                  var pct = Math.round(((p.compare_at_price - p.price) / p.compare_at_price) * 100);
                  if (pct > 0 && p.available) badge = '<span class="pmh-rvc__badge pmh-rvc__badge--sale">-' + pct + '%</span>';
                }
                if (!p.available) badge = '<span class="pmh-rvc__badge">' + escapeHtml(soldLabel) + '</span>';
              }
              return (
                '<li class="pmh-rail__item"><a class="pmh-rvc" href="' + escapeHtml(p.url) + '">' +
                '<span class="pmh-rvc__media">' + img + badge + '</span>' +
                '<span class="pmh-rvc__title">' + escapeHtml(title) + '</span>' +
                '<span class="pmh-rvc__price">' + price + '</span>' +
                '</a></li>'
              );
            })
            .join('');
          this.hidden = false;
          var section = this.closest('.pmh-rv-section');
          if (section) section.hidden = false;
          var rail = this.querySelector('pmh-rail');
          if (rail && typeof rail.refresh === 'function') {
            window.requestAnimationFrame(function () {
              rail.refresh();
            });
          }
        }
      }
    );
  }

  function init() {
    initLiveUpdates();
    recordCurrentProduct();
    initAllGalleries();
    var onGalleryMq = function () {
      initAllGalleries();
    };
    if (galleryMq.addEventListener) galleryMq.addEventListener('change', onGalleryMq);
    else if (galleryMq.addListener) galleryMq.addListener(onGalleryMq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
